import { Box, styled, Typography } from '@mui/material';

export const PersonalImpactCalendarWrapper = styled(Box)(({ theme }) => ({
  padding         : { xs: '20px 10px', md: '20px 30px' },
  border          : `1px solid ${theme.palette.primary.gray3}`,
  borderRadius    : '10px',
  color           : '#231F20',
  display         : 'flex',
  flexDirection   : 'column',
  backgroundColor : theme.palette.primary.white,
  width           : { md: '40%' },
}));

export const Header = styled('div')({
  '& div' : {
    display        : 'flex',
    justifyContent : 'space-between',
    alignItems     : 'center',
    marginBottom   : '6px',
  },
});

export const Title = styled(Typography)(({ theme }) => ({
  fontFamily : 'Montserrat',
  fontWeight : '700',
  color      : theme.palette.primary.gray8,
}));

export const ImpactDuration = styled(Typography)(({ theme }) => ({
  fontFamily : 'Montserrat',
  color      : theme.palette.primary.grey5,
}));

export const Content = styled('div')(({ theme }) => ({
  display                                    : 'flex',
  flexDirection                              : 'column',
  gap                                        : '20px',
  padding                                    : '10px 0',
  height                                     : '100%',
  '& .MuiInputLabel-root, .MuiSelect-select' : {
    color : theme.palette.primary.gray8,
  },
  '& .MuiInputBase-root' : {
    borderRadius : '10px',
    borderColor  : theme.palette.primary.grey4,
  },
}));
